/* C23 · Cost-per-cut calculator — price ÷ (cuts × 312 × years).
   312 working days = honest 6-day week (v2.2 divergence, deliberate).
   Currency: Intl.NumberFormat with the cart's ISO code (data-currency) —
   symbol always matches the market, never hardcoded. */
(() => {
  if (window.__jpCpcInit) return;
  window.__jpCpcInit = true;

  const init = (root) => {
    if (root.dataset.jpCpcReady) return;
    root.dataset.jpCpcReady = 'true';
    const cents = parseInt(root.dataset.priceCents, 10) || 30000;
    const currency = root.dataset.currency || 'GBP';
    const lang = document.documentElement.lang || 'en';
    const cuts = root.querySelector('[data-cpc-cuts]');
    const years = root.querySelector('[data-cpc-years]');
    const outCuts = root.querySelector('[data-cpc-cuts-out]');
    const outYears = root.querySelector('[data-cpc-years-out]');
    const result = root.querySelector('[data-cpc-result]');
    if (!cuts || !years || !result) return;

    const fmt = (value) => {
      const digits = value < 0.01 ? 3 : 2;
      try {
        return new Intl.NumberFormat(lang, {
          style: 'currency',
          currency,
          minimumFractionDigits: digits,
          maximumFractionDigits: digits,
        }).format(value);
      } catch {
        return value.toFixed(digits);
      }
    };

    const update = () => {
      const c = parseInt(cuts.value, 10);
      const y = parseInt(years.value, 10);
      outCuts.textContent = c;
      outYears.textContent = y;
      /* human-readable value for screen readers (raw number alone lacks unit context); reuses the rendered locale unit */
      cuts.setAttribute('aria-valuetext', (outCuts.closest('output')?.textContent || c).toString().trim());
      years.setAttribute('aria-valuetext', (outYears.closest('output')?.textContent || y).toString().trim());
      result.textContent = fmt(cents / 100 / (c * 312 * y));
    };
    cuts.addEventListener('input', update);
    years.addEventListener('input', update);
    update();
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-jp-cpc]').forEach(init);
  });
  /* Customiser re-renders replace section DOM — re-init fresh nodes */
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-jp-cpc]').forEach(init);
  });
})();
